import { cn } from '@/utils/style';

interface Props {
  image?: string;
  imageAlt?: string;
  name?: string;
  pharmaceuticalEffectLiteracy?: string;
}

const MedicineImageWithName = (props: Props) => {
  return (
    <section
      className={cn(['flex flex-col gap-[32px] px-[24px] py-[28px] md:flex-row md:gap-[32px]'])}
      suppressHydrationWarning
    >
      {props.image && (
        <img src={props.image} alt={props.imageAlt} className='w-full rounded-[20px] object-contain md:w-[220px]' />
      )}
      <div className='flex flex-col justify-center gap-[2px]'>
        <span className='typography-ui-15r select-text text-gray-400'>{props.pharmaceuticalEffectLiteracy}</span>
        <h1 className='typography-ui-19sb select-text text-gray-900'>{props.name}</h1>
      </div>
    </section>
  );
};

export default MedicineImageWithName;
